
var RandomNoiseShader = {
    uniforms: {
        "tDiffuse": { value: null },
        "mixFactor": { value: 0.1 },
        "factor": { value: 10000 },
        "resolution": { value: null },
    },

    vertexShader: `
        varying vec2 vUv;

        void main() {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
    `,

    fragmentShader:`
        uniform sampler2D tDiffuse;
        uniform float factor;
        uniform float mixFactor;
        uniform vec2 resolution;
        varying vec2 vUv;

        float random (vec2 st) {
            return fract(sin(dot(st.xy, vec2(12.9898,78.233)))* 43758.5453123);
        }

        void main() {
            vec4 texel = texture2D(tDiffuse, vUv);
            vec2 st = gl_FragCoord.xy / resolution;
            if (texel.a <= 0.0) {
                gl_FragColor = texel;
                return;
            }
            
            vec2 ipos = floor(st*factor);
            //vec3 color_mix = mix(texel.rgb, vec3(random(ipos)), mixFactor);
            vec3 color_mix = texel.rgb * (vec3(random(ipos)) + vec3(mixFactor));
            //gl_FragColor = vec4(vec3(random(ipos)), texel.a);
            //gl_FragColor = vec4(vec3(random(ipos)), 1.0);
            gl_FragColor = vec4(color_mix, texel.a);
        }
    `,

};

export { RandomNoiseShader };
